import React from 'react';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';

const ExcelExport = ({ data, fileName }) => {
    const exportToExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Leave Report');

        // Border Style Function
        const applyBorder = (cell) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        };

        // Header Colors
        const sectionHeaderColor = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9EAD3' } };
        const columnHeaderColor = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } };

        // Step 1: Get all unique leave types dynamically
        const leaveTypes = [...new Set(data.flatMap(emp => emp.leaveData.map(ld => ld.leave_type)))];

        // Step 2: Create header row dynamically
        worksheet.mergeCells('A1:A2'); // Employee Name Column
        worksheet.getCell('A1').value = "Employee Name";
        worksheet.getCell('A1').font = { bold: true, size: 12 };
        worksheet.getCell('A1').alignment = { horizontal: 'center', vertical: 'middle' };
        worksheet.getCell('A1').fill = sectionHeaderColor;
        applyBorder(worksheet.getCell('A1'));

        let colIndex = 2;
        leaveTypes.forEach(type => {
            worksheet.mergeCells(1, colIndex, 1, colIndex + 2);
            worksheet.getCell(1, colIndex).value = type;
            worksheet.getCell(1, colIndex).font = { bold: true, size: 12 };
            worksheet.getCell(1, colIndex).alignment = { horizontal: 'center' };
            worksheet.getCell(1, colIndex).fill = sectionHeaderColor;
            applyBorder(worksheet.getCell(1, colIndex));

            worksheet.getCell(2, colIndex).value = "Total Leaves";
            worksheet.getCell(2, colIndex + 1).value = "Used Leaves";
            worksheet.getCell(2, colIndex + 2).value = "Remaining Leaves";

            [colIndex, colIndex + 1, colIndex + 2].forEach(i => {
                worksheet.getCell(2, i).fill = columnHeaderColor;
                worksheet.getCell(2, i).font = { bold: true };
                worksheet.getCell(2, i).alignment = { horizontal: 'center' };
                applyBorder(worksheet.getCell(2, i));
            });

            colIndex += 3;
        });

        // Step 3: Populate Data
        data.forEach((employee) => {
            const rowData = [employee.employee_name];

            leaveTypes.forEach(type => {
                const leaveRecord = employee.leaveData.find(l => l.leave_type === type);
                rowData.push(
                    leaveRecord ? `${leaveRecord.total_leaves} Hrs.` : 0,
                    leaveRecord ? `${leaveRecord.used_leaves} Hrs.` : 0,
                    leaveRecord ? `${leaveRecord.pending_leaves} Hrs.` : 0
                );
            });

            const addedRow = worksheet.addRow(rowData);
            addedRow.eachCell((cell, colNumber) => {
                cell.alignment = { horizontal: 'center' };
                applyBorder(cell);
                if (colNumber === 1) {
                    cell.font = { bold: true };
                }
            });
        });

        // Step 4: Auto adjust column widths
        worksheet.columns.forEach((column) => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, cell => {
                if (cell.value && cell.value.toString().length > maxLength) {
                    maxLength = cell.value.toString().length;
                }
            });
            column.width = maxLength + 2;
        });

        // Step 5: Save the Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        saveAs(blob, `${fileName}.xlsx`);
    };

    return (
        <button className="btn btn-secondary" onClick={exportToExcel}>
            <i className="fa fa-file-excel"></i> &nbsp; Export to Excel
        </button>
    );
}

export default ExcelExport;